import { Reveal } from "./Reveal";
import { Check } from "lucide-react";

const plans = [
  {
    testid: "pricing-card-inicial",
    name: "Formação Inicial TVDE",
    format: "50 horas · B-learning",
    price: "155€",
    oldPrice: "200€",
    badge: "Valor do exame incluído",
    highlight: true,
    formacao: "Formação Inicial",
    desc: "Indicada para quem pretende começar a exercer a atividade de motorista TVDE e conduzir na Bolt.",
    requirements: [
      "Cartão de Cidadão / Título de Residência",
      "Carta de condução portuguesa há mais de 3 anos",
      "Morada completa",
      "Contacto telefónico e email",
      "Matrícula do carro para a componente prática",
    ],
  },
  {
    testid: "pricing-card-renovacao",
    name: "Renovação TVDE",
    format: "8 horas · Presencial ou E-learning",
    price: "67.50€",
    oldPrice: "90€",
    badge: "Valor do exame incluído",
    highlight: false,
    formacao: "Renovação",
    desc: "Destinada a motoristas TVDE que pretendem renovar a sua certificação e continuam a cumprir os requisitos de acesso.",
    requirements: [
      "Cartão de Cidadão / Título de Residência",
      "Carta de condução portuguesa",
      "Morada completa",
      "Contacto telefónico e email",
      "Cartão TVDE válido",
    ],
  },
];

export default function Pricing() {
  return (
    <section id="precos" data-testid="pricing-section" className="border-y border-black/5 bg-[#fafafa] py-28 sm:py-36">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="font-mono-x text-xs uppercase tracking-[0.35em] text-[#34d186]">Preços</p>
          <h2 className="mt-4 max-w-3xl font-display text-2xl font-bold tracking-tight text-[#171717] sm:text-3xl lg:text-4xl" data-testid="pricing-title">
            Valores transparentes, sem custos escondidos.
          </h2>
          <p className="mt-5 max-w-2xl text-base text-[#737373] sm:text-lg">
            O investimento na tua carreira de motorista Bolt — com o valor do exame sempre incluído.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-8 lg:grid-cols-2">
          {plans.map((p, i) => (
            <Reveal key={p.name} delay={i * 0.12}>
              <div
                data-testid={p.testid}
                className={`relative flex h-full flex-col rounded-3xl p-8 transition-all duration-500 sm:p-10 ${
                  p.highlight
                    ? "border-2 border-[#34d186]/50 bg-[#f5f5f5] shadow-[0_0_50px_rgba(52,209,134,0.12)] hover:shadow-[0_0_70px_rgba(52,209,134,0.22)]"
                    : "border border-black/10 bg-[#ffffff] hover:border-[#34d186]/40"
                }`}
              >
                <span className="inline-flex w-fit items-center rounded-full border border-[#34d186]/40 bg-[#34d186]/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-widest text-[#34d186]">
                  {p.badge}
                </span>
                <h3 className="mt-6 font-display text-xl font-bold text-[#171717] sm:text-2xl">{p.name}</h3>
                <p className="mt-1 font-mono-x text-xs uppercase tracking-widest text-[#737373]">{p.format}</p>
                <div className="mt-6 flex items-end gap-3">
                  <span className="pb-1 font-display text-xl font-semibold text-[#737373] line-through decoration-[#ef4444]/70 decoration-2" data-testid={`${p.testid}-old-price`}>{p.oldPrice}</span>
                  <span className="font-display text-5xl font-extrabold text-[#f5c842]" data-testid={`${p.testid}-price`}>{p.price}</span>
                  <span className="pb-1.5 text-sm text-[#737373]">/ curso completo</span>
                </div>
                <p className="mt-4 text-sm leading-relaxed text-[#737373]">{p.desc}</p>
                <div className="my-7 h-px bg-black/10" />
                <p className="mb-4 font-mono-x text-[10px] uppercase tracking-[0.3em] text-[#737373]">Requisitos e documentos</p>
                <ul className="flex-1 space-y-3">
                  {p.requirements.map((r) => (
                    <li key={r} className="flex items-start gap-3 text-sm text-[#171717]/90">
                      <Check size={16} className="mt-0.5 shrink-0 text-[#34d186]" />
                      {r}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
